/**
 * GA4 Airbyte Form Component
 *
 * This form component handles Google Analytics 4 (Airbyte) connector setup.
 * Uses the generic Airbyte additional configuration flow.
 *
 * Connector ID: google_analytics_4_airbyte
 *
 * This fetches configuration from the API endpoint:
 * /company-connector/{id}/airbyte-properties
 *
 * The form displays dynamic inputs based on the connector's additional_config schema.
 */

import React from "react"
import AdditionalConfigForm from "../AdditionalConfigForm"
import useConnectors from "~/ui-rtk/hooks/connectors"
import type { CustomerConnectorDialogFormPropsWithoutUri } from "../types"

type GA4AirbyteFormProps = CustomerConnectorDialogFormPropsWithoutUri

const GA4AirbyteForm: React.FC<GA4AirbyteFormProps> = ({
  companyConnectorId,
  isOpen,
  onClose,
}) => {
  const { getConnectorById } = useConnectors()

  // Get GA4 Airbyte connector configuration
  const connector = getConnectorById("google_analytics_4_airbyte")

  if (!connector) {
    return null
  }

  return (
    <AdditionalConfigForm
      companyConnectorId={companyConnectorId ?? ""}
      connector={connector}
      isOpen={isOpen}
      onClose={onClose}
    />
  )
}

export default GA4AirbyteForm
